export const ALL_PERMISSIONS = [
  { key: "overview", label: "数据概览" },
  { key: "clients", label: "客户管理" },
  { key: "progress", label: "进度管理" },
  { key: "finance", label: "财务管理" },
  { key: "system", label: "系统管理" },
];

export const ALL_TABS = [
  { key: "notification", label: "通知推送", icon: "ri-send-plane-line", perm: "system", sub: "notification" },
  { key: "scheduled", label: "定时任务", icon: "ri-time-line", perm: "system", sub: "notification" },
  { key: "notification_history", label: "通知历史", icon: "ri-message-2-line", perm: "system", sub: "notification" },
  { key: "logs", label: "操作日志", icon: "ri-history-line", perm: "system", sub: "logs" },
  { key: "roles", label: "角色管理", icon: "ri-shield-keyhole-line", perm: "system", sub: "roles" },
  { key: "employees", label: "员工管理", icon: "ri-team-line", perm: "system", sub: "employees" },
];

export const SERVICE_PLAN_LABELS: Record<string, string> = {
  surrogacy_has_embryo: "单助孕·已有胚胎",
  surrogacy_transfer_embryo: "单助孕·转入胚胎",
  ivf_self: "试管助孕·自精自卵",
  ivf_donor: "试管助孕·捐赠助孕",
  embryo_transport: "胚胎转运·胚胎转出",
  fertility_preservation: "生育力保存·生育力保存",
};

export const COUNTRIES = ["日本", "泰国", "马来西亚", "格鲁吉亚", "哥伦比亚", "吉尔吉斯斯坦"];

export type TabKey = "notification" | "scheduled" | "notification_history" | "logs" | "roles" | "employees";

export const MODULE_MAP: Record<string, string> = {
  login: "系统管理", create_client: "客户管理", edit_client: "客户管理", delete_client: "客户管理", assign_advisor: "客户管理",
  progress_update: "进度管理", upload_file: "进度管理", delete_file: "进度管理",
  send_notification: "通知推送",
  create_scheduled_notification: "通知推送", update_scheduled_notification: "通知推送", cancel_scheduled_notification: "通知推送", send_scheduled_now: "通知推送",
  create_employee: "系统管理", update_employee: "系统管理", delete_employee: "系统管理",
  create_role: "系统管理", update_role: "系统管理", delete_role: "系统管理",
  change_password: "系统管理",
};

export const CLIENT_FIELD_LABELS: Record<string, string> = {
  name: "客户姓名", phone: "联系电话", password: "登录密码", id_number: "身份证号",
  passport_number: "护照号", wechat: "微信号", is_single: "是否单身",
  partner_name: "伴侣姓名", partner_id_number: "伴侣身份证号", partner_passport: "伴侣护照号",
  partner_phone: "伴侣电话", partner_wechat: "伴侣微信", country: "国家",
  service_plan: "服务方案", notes: "备注", status: "状态", tags: "标签",
  joint_stimulation: "联合促排", gender: "性别", partner_gender: "伴侣性别",
  client_source: "客户来源", advisor_name: "专属顾问", advisor_employee_id: "专属顾问",
};

export const MODULE_ACTION_OPTIONS: Record<string, Array<{ value: string; label: string }>> = {
  "客户管理": [
    { value: "create_client", label: "创建客户" },
    { value: "edit_client", label: "编辑客户" },
    { value: "delete_client", label: "删除客户" },
    { value: "assign_advisor", label: "分配顾问" },
  ],
  "进度管理": [
    { value: "progress_update", label: "进度更新" },
    { value: "upload_file", label: "文件上传" },
    { value: "delete_file", label: "文件删除" },
  ],
  "通知推送": [
    { value: "send_notification", label: "发送通知" },
    { value: "scheduled_notification", label: "定时通知" },
  ],
  "系统管理": [
    { value: "login", label: "员工登录" },
    { value: "change_password", label: "更改密码" },
    { value: "create_employee", label: "创建员工" },
    { value: "update_employee", label: "编辑员工" },
    { value: "delete_employee", label: "删除员工" },
    { value: "create_role", label: "创建角色" },
    { value: "update_role", label: "编辑角色" },
    { value: "delete_role", label: "删除角色" },
  ],
};

export const ALL_LOG_ACTIONS = [
  { value: "login", label: "员工登录" },
  { value: "change_password", label: "更改登录密码" },
  { value: "create_client", label: "创建客户" },
  { value: "edit_client", label: "编辑客户" },
  { value: "delete_client", label: "删除客户" },
  { value: "assign_advisor", label: "分配顾问" },
  { value: "progress_update", label: "进度更新" },
  { value: "upload_file", label: "文件上传" },
  { value: "delete_file", label: "文件删除" },
  { value: "send_notification", label: "发送通知" },
  { value: "scheduled_notification", label: "定时通知" },
  { value: "create_employee", label: "创建员工" },
  { value: "update_employee", label: "编辑员工" },
  { value: "delete_employee", label: "删除员工" },
  { value: "create_role", label: "创建角色" },
  { value: "update_role", label: "编辑角色" },
  { value: "delete_role", label: "删除角色" },
];

export const CRITICAL_ACTIONS = new Set(["delete_client", "delete_role", "delete_employee"]);

export function formatDateTime(s: string) {
  const d = new Date(s);
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, "0")}.${String(d.getDate()).padStart(2, "0")} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}